import { sendSumoLog } from './sumoLogger';
import { fetchStandbyInspectorsList } from './fetchStandbyInspectorsList';
import { updateError } from '../../store';
import { CREATE_STANDBY_INSPECTOR } from '../queries/queries';
import GetApolloClient from '../../Apollo';

/**
 * Create a new Standby Inspector (and associated User).
 *
 * @param token - authentication token from active auth.
 * @param dispatch - redux dispatch to dispatch state changes.
 * @param fullUserBody - the data for the Standby Inspector/User records to insert.
 * @returns {Promise<[StandbyInspectors]>} - The updated list of Standby Inspectors.
 */
export const postStandbyInspector = async (token, dispatch, fullUserBody) => {
  const client = GetApolloClient(token);

  try {
    /* eslint-disable no-unused-vars */
    const {
      data: { createStandbyInspector: id },
    } = await client.mutate({
      mutation: CREATE_STANDBY_INSPECTOR,
      variables: { input: { ...fullUserBody.user } },
    });

    fetchStandbyInspectorsList(token, dispatch);
  } catch (error) {
    const isInternalError = error instanceof Error;
    const errorType = 'postStandbyInspector';
    const errorCode = isInternalError ? 500 : error.errorCode;
    sendSumoLog(errorType, error.message, errorCode, dispatch);
    updateError(error, dispatch);
    return null;
  }
};
